import backgroundOverlay from "@/app/(public)/shared/assets/background-overlay2.png";
import { ReactNode } from "react";

interface LandingPageLayoutProps {
  children: ReactNode;
  /** Overrides the default Nowadays-branded purple shell with an event's own background color
   *  (e.g. an attendee dashboard matching its landing page's theme). The purple overlay graphic
   *  is skipped in that case since it assumes the default purple base. */
  backgroundColor?: string | null;
}

export default function LandingPageLayout({ children, backgroundColor }: LandingPageLayoutProps) {
  return (
    <div
      className={`justify-center content-center w-screen flex items-center min-h-screen flex-col relative overflow-x-clip ${backgroundColor ? "" : "bg-landing-primary"}`}
      style={backgroundColor ? { backgroundColor } : undefined}
    >
      {/* Background image with opacity — default shell only */}
      {!backgroundColor && (
        <div
          className="absolute inset-0 pointer-events-none z-0"
          style={{
            backgroundImage: `url(${backgroundOverlay.src})`,
            backgroundSize: "100% auto",
            backgroundPosition: "center top",
            backgroundRepeat: "no-repeat",
            opacity: 0.2,
          }}
        />
      )}

      {/* Content with higher z-index */}
      <div className="relative z-10 w-full flex flex-col items-center min-h-screen">{children}</div>
    </div>
  );
}
